// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606180004/js/" + chunkId + "." + {"44":"aa4bf4cd","225":"e039dfba","481":"4cd69b0c","486":"012008f8","770":"479f6f81"}[chunkId] + ".0.037568792520488836.chunk.js";
};